import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-36598d4a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "view-wrapper"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "text"
};
var _hoisted_4 = {
  class: "text"
};
var _hoisted_5 = {
  class: "progress"
};
var _hoisted_6 = {
  class: "percentage"
};
var _hoisted_7 = {
  class: "cancel-container"
};
var _hoisted_8 = {
  class: "taking-too-long"
};
import { computed, onMounted } from "vue";
import { allowAppRefresh, clearPendingLogsToSync, getUnsyncedLogs, preventAppRefresh, resetLogSyncIndex } from "@/utils/vue-helpers/log";
import { resetGrowingCollections, setDBReset } from "@/utils/vue-helpers/db";
import LogsModule from "@/store/modules/logs";
import { LogService } from "@/services/logging";
import AppModule from "@/store/modules/app";
export default /*#__PURE__*/_defineComponent({
  __name: 'RestoreLogs',
  setup: function setup(__props) {
    var percentage = computed(function () {
      var logsPendingLength = LogsModule.logsPendingSynchronization.length;
      var logIndex = LogsModule.logIndex;

      if (logsPendingLength === 0) {
        return 100;
      } // Ensure logIndex is within bounds


      var clampedLogIndex = Math.min(Math.max(logIndex, 0), logsPendingLength - 1);
      return Math.round(clampedLogIndex * 100 / logsPendingLength);
    });

    var cancelRecovery = function cancelRecovery() {
      LogService.infoDirect("User canceled logs recovery at ".concat(percentage.value, "%"));
      allowAppRefresh();
      AppModule.setIsRestoringLogs(false);
    };

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var restoredLogs;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // allow aborting recovery after 90 seconds
              LogService.infoDirect("Started restoring logs");
              preventAppRefresh();
              _context.prev = 2;
              _context.next = 5;
              return getUnsyncedLogs();

            case 5:
              restoredLogs = _context.sent;

              if (!restoredLogs) {
                _context.next = 14;
                break;
              }

              LogService.infoDirect("Successfully restored logs, going to clear pending logs array and reset indexedDB collections"); // logs were successfully synced, clear the pending logs array and reset indexedDB collections

              clearPendingLogsToSync();
              resetLogSyncIndex();
              _context.next = 12;
              return resetGrowingCollections();

            case 12:
              setDBReset(true);
              LogService.infoDirect("Successfully cleared pending logs and restored indexedDB collections");

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              LogService.infoDirect("Error encountered while synching logs", {
                error: _context.t0
              });

            case 19:
              _context.prev = 19;
              allowAppRefresh();
              AppModule.setIsRestoringLogs(false);
              return _context.finish(19);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16, 19, 23]]);
    })));
    return function (_ctx, _cache) {
      var _component_el_progress = _resolveComponent("el-progress");

      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("recover-logs.hold-on")), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("app-update.text")), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("app-update.do-not-refresh")), 1), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_progress, {
        "show-text": false,
        "stroke-width": 24,
        percentage: percentage.value
      }, null, 8, ["percentage"])]), _createElementVNode("h1", _hoisted_6, _toDisplayString(percentage.value) + "%", 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t("recover-logs.taking-too-long")), 1), _createVNode(_component_el_button, {
        type: "primary",
        link: "",
        style: {
          "font-size": "x-large"
        },
        onClick: cancelRecovery
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("recover-logs.cancel-and-retry")), 1)];
        }),
        _: 1
      })])]);
    };
  }
});